module.exports = __webpack_public_path__ + "static/me-3783226d15e938981e3ae9c482655299.jpg";